import { Common, ApiBind } from './common.model';
import {OSGroupOS} from './os-group-os.model';

export class OSGroup extends Common {
  @ApiBind({ column: 'id' })
  id: number;

  @ApiBind({ column: 'name' })
  name: string;

  @ApiBind({ column: 'white_list', model: (values) => values.map(v => new OSGroupOS(v)) })
  whiteList: OSGroupOS[];

  @ApiBind({ column: 'black_list', model: (values) => values.map(v => new OSGroupOS(v)) })
  blackList: OSGroupOS[];

  @ApiBind({ column: 'updated_at' })
  updatedAt: string;

  public toDeleteItemJSON() {
    return { id: this.convertJSONObject(this.id), updated_at: this.convertJSONObject(this.updatedAt) };
  }
}
